import React, { useState, useEffect } from 'react';
import { auth } from './auth';
import { getDocs, collection } from 'firebase/firestore';
import { db } from './firebase';

export default function UserForm({ onSave, editingUser, onCancel }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isSCUser, setIsSCUser] = useState(false);

  useEffect(() => {
    if (editingUser) {
      setName(editingUser.name);
      setEmail(editingUser.email);
    } else {
      setName('');
      setEmail('');
    }
  }, [editingUser]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      if (user && user.email) {
        const usersSnapshot = await getDocs(collection(db, 'users'));
        let found = false;
        usersSnapshot.forEach(doc => {
          const data = doc.data();
          if (data.email && data.email.toLowerCase() === user.email.toLowerCase()) {
            found = true;
          }
        });
        setIsSCUser(found);
      } else {
        setIsSCUser(false);
      }
    });
    return () => unsubscribe();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isSCUser) {
      alert('Only SC Users are allowed!');
      return;
    }
    if (!name || !email) return;
    // Check for duplicate name or email
    const usersSnapshot = await getDocs(collection(db, 'users'));
    let duplicate = false;
    usersSnapshot.forEach(doc => {
      const data = doc.data();
      if (
        (data.name && data.name.trim().toLowerCase() === name.trim().toLowerCase()) ||
        (data.email && data.email.trim().toLowerCase() === email.trim().toLowerCase())
      ) {
        duplicate = true;
      }
    });
    if (duplicate) {
      alert('A user with this name or email already exists.');
      return;
    }
    onSave({ name, email });
    setName('');
    setEmail('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <h2>{editingUser ? 'Edit SC User' : 'Register SC User'}</h2>
      <div>
        <label>Name:</label>
        <input value={name} onChange={e => setName(e.target.value)} required />
      </div>
      <div>
        <label>Email:</label>
        <input value={email} onChange={e => setEmail(e.target.value)} required />
      </div>
      <button type="submit">{editingUser ? 'Update' : 'Register'}</button>
      {editingUser && <button type="button" onClick={onCancel}>Cancel</button>}
    </form>
  );
}
